export default defineNuxtPlugin( () => {
  const { can } = useAuth()
  return { provide: { can }}
})